import { ReactElement, useEffect, useLayoutEffect, useRef } from 'react';
import { components, GroupTypeBase, MenuProps } from 'react-select';

import { IOption } from '~/types';

const ScrollIntoViewMenu = (
  props: MenuProps<IOption, boolean, GroupTypeBase<IOption>>,
): ReactElement => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const container = ref.current?.closest<HTMLElement>('[data-menu-scroll-container]');
    if (!container) {
      return undefined;
    }

    container.style.minHeight = '';
    const maxHeight = parseFloat(getComputedStyle(container).maxHeight) || Infinity;
    container.style.minHeight = `${Math.min(container.scrollHeight, maxHeight)}px`;

    return () => {
      container.style.minHeight = '';
    };
  });

  useEffect(() => {
    ref.current?.firstElementChild?.scrollIntoView?.({ block: 'nearest' });
  }, []);

  return (
    <div ref={ref}>
      <components.Menu {...props} />
    </div>
  );
};

export default ScrollIntoViewMenu;
